import React from 'react';
import PropTypes from 'prop-types';
import Script from "next/script"
import DOMPurify from 'isomorphic-dompurify'
import { customJsonstringify } from '../../../utils/helpers/customJsonstringify.helpers';

class Seo extends React.PureComponent {
  static propTypes = {
    locale: PropTypes.string.isRequired,
  };

  render() {
    const { locale } = this.props;
    const seoConfig = require(`../../../data/${locale}/seo.json`);
    return (
      <>
        <Script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:DOMPurify.sanitize( `{"@context":"${
              seoConfig.context
            }","@type":"Organization","name":"${seoConfig.name}","url":"${
              seoConfig.url
            }","logo":"${seoConfig.logo}","parentorganization":"${
              seoConfig.parentorganization
            }","sameAs":${customJsonstringify(seoConfig.sameAs)}
            }`),
          }}
        />
      </>
    );
  }
}

export default Seo;
